import { UseFormGetValues, FieldValues } from 'react-hook-form'
import { DataItem } from 'scrivito'

import { EnumValue } from '@/Data/typesV2'
import { getLocalizedSchemaEnumValues } from '@/utils/schemaLocalization'

export const getDataItemEnumSelectArray = (
  getValues?: UseFormGetValues<FieldValues>,
  enumValues?: EnumValue[],
  dataItem?: DataItem,
) => {
  const localizedEnumValues = getLocalizedSchemaEnumValues(enumValues)

  const options = localizedEnumValues?.flatMap((enumValue) => {
    const constraints = enumValue.constraints

    if (!constraints) {
      return {
        label: enumValue.title,
        value: enumValue.value,
      }
    }

    const dependencyFields = Object.keys(constraints)

    const possibleOptions = dependencyFields.flatMap((field) => {
      const fieldValue = dataItem?.get(field) as string

      // return the current value of the attribute/field as an option
      if (enumValue.value === fieldValue) {
        return { value: enumValue.value, label: enumValue.title }
      }

      let depsFieldValue = fieldValue

      if (getValues) {
        depsFieldValue = getValues(field)
      }

      if (
        enumValue.constraints?.[field]?.includes(depsFieldValue ?? fieldValue)
      ) {
        return { value: enumValue.value, label: enumValue.title }
      }

      return []
    })

    if (possibleOptions.length === dependencyFields.length) {
      return possibleOptions[0]
    }

    return []
  })

  return options?.filter((e) => e !== undefined)
}
